import { useEffect, useState } from "react";
import { toast } from "sonner";
import { cmsApi, apiError } from "../api";
import { ImageUpload } from "../components/ImageUpload";
import { usePageData, PageTitle, Card, TextField, SaveBar, Spinner } from "../components/admin-ui";

export default function BusinessAdmin() {
  const { data, loading } = usePageData("/website-admin/business");
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (data) setForm((f) => f || data); }, [data]);
  if (loading || !form) return <Spinner />;
  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));
  const save = async () => {
    if (form.email && !/^\S+@\S+\.\S+$/.test(form.email)) { toast.error("Bitte eine gültige E-Mail-Adresse angeben"); return; }
    setSaving(true);
    try { const { id, updated_at, updated_by, ...body } = form; await cmsApi.put("/website-admin/business", body); toast.success("Geschäftsinformationen gespeichert"); }
    catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };
  return (
    <div data-testid="business-admin-page">
      <PageTitle title="Geschäftsinformationen" text="Name, Logo, Adresse, Kontakt und Social Media – erscheinen auf allen Seiten." />
      <div className="grid lg:grid-cols-12 gap-6">
        <div className="lg:col-span-7 space-y-6">
          <Card title="Allgemein">
            <div className="space-y-4">
              <TextField label="Name des Geschäfts" value={form.name} onChange={set("name")} testid="biz-name-input" />
              <TextField label="Slogan / Untertitel" value={form.tagline} onChange={set("tagline")} testid="biz-tagline-input" />
              <TextField label="Beschreibung" value={form.description} onChange={set("description")} textarea rows={5} testid="biz-description-input" />
            </div>
          </Card>
          <Card title="Adresse & Standort">
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="sm:col-span-2"><TextField label="Straße und Hausnummer" value={form.street} onChange={set("street")} testid="biz-street-input" /></div>
              <TextField label="PLZ" value={form.postal_code} onChange={set("postal_code")} testid="biz-postal-input" />
              <TextField label="Ort" value={form.city} onChange={set("city")} testid="biz-city-input" />
              <div className="sm:col-span-2"><TextField label="Land" value={form.country} onChange={set("country")} testid="biz-country-input" /></div>
              <div className="sm:col-span-2"><TextField label="Google-Maps-Link" value={form.maps_url} onChange={set("maps_url")} placeholder="https://maps.app.goo.gl/…" testid="biz-maps-url-input" hint="Link zum Öffnen der Route." /></div>
              <div className="sm:col-span-2"><TextField label="Google-Maps-Einbettung (Embed-URL)" value={form.maps_embed_url} onChange={set("maps_embed_url")} placeholder="https://www.google.com/maps/embed?pb=…" testid="biz-maps-embed-input" hint="Google Maps → Teilen → „Karte einbetten“ → nur die src-URL aus dem iframe kopieren." /></div>
            </div>
          </Card>
        </div>
        <div className="lg:col-span-5 space-y-6">
          <Card title="Logo" text="Erscheint in der Navigation und im Footer. Vollständige Logo-Verwaltung unter „Logo & Branding“.">
            <ImageUpload value={form.logo_media_id} onChange={set("logo_media_id")} kind="logo" label="" aspect="aspect-[3/1]" testid="logo-upload" />
          </Card>
          <Card title="Kontakt">
            <div className="space-y-4">
              <TextField label="Telefon" value={form.phone} onChange={set("phone")} placeholder="+49 …" testid="biz-phone-input" />
              <TextField label="WhatsApp" value={form.whatsapp} onChange={set("whatsapp")} placeholder="+49 … (mit Ländervorwahl)" testid="biz-whatsapp-input" />
              <TextField label="E-Mail" type="email" value={form.email} onChange={set("email")} testid="biz-email-input" />
            </div>
          </Card>
          <Card title="Social Media">
            <div className="space-y-4">
              <TextField label="Instagram" value={form.instagram} onChange={set("instagram")} placeholder="https://instagram.com/…" testid="biz-instagram-input" />
              <TextField label="Facebook" value={form.facebook} onChange={set("facebook")} placeholder="https://facebook.com/…" testid="biz-facebook-input" />
              <TextField label="TikTok" value={form.tiktok} onChange={set("tiktok")} placeholder="https://tiktok.com/@…" testid="biz-tiktok-input" />
              <div className="grid grid-cols-2 gap-3">
                <TextField label="Weiterer Link – Name" value={form.other_link_label} onChange={set("other_link_label")} testid="biz-other-label-input" />
                <TextField label="Weiterer Link – URL" value={form.other_link_url} onChange={set("other_link_url")} testid="biz-other-url-input" />
              </div>
            </div>
          </Card>
        </div>
      </div>
      <SaveBar onSave={save} saving={saving} testid="business-save" />
    </div>
  );
}
